import { Config } from './config';
export const environment = {
  production: false,
  firebase: {
    apiKey: Config.DatabaseConfig.apiKey,
    authDomain: Config.DatabaseConfig.authDomain,  
    projectId: Config.DatabaseConfig.projectId,
    storageBucket: Config.DatabaseConfig.storageBucket,
    messagingSenderId: Config.DatabaseConfig.messagingSenderId,
    appId: Config.DatabaseConfig.appId,
    measurementId: Config.DatabaseConfig.measurementId
  }
}; 